import { Trans } from "@lingui/macro";
import IconArrowBack from "@mui/icons-material/ArrowBack";
import IconYoutube from "@mui/icons-material/YouTube";
import {
  UiBox,
  UiButton,
  UiDialogResponsive,
  UiIconPosts,
  UiIconWatermark,
} from "@smp/ui";
import { testAppendAttr } from "@smp/utils";
import { useState } from "react";

import { useContextApp } from "@/screens/app/context/app";

import { useStyles } from "./dialog_plan_boost.css";
import { Posts } from "./posts";
import { Video } from "./video";
import { Watermark } from "./watermark";

export const DialogPlanBoost = ({
  feature,
  onClose,
  onClickTryPro,
}: {
  feature?: "posts" | "video" | "watermark";
  onClose: () => void;
  onClickTryPro?: () => void;
}) => {
  const {
    state: { me },
  } = useContextApp();
  const [featureSelected, setFeatureSelected] = useState(feature);
  const classes = useStyles();

  const handleClickBack = () => {
    setFeatureSelected(undefined);
  };

  const handleClickPosts = () => {
    setFeatureSelected("posts");
  };

  const handleClickVideo = () => {
    setFeatureSelected("video");
  };

  const handleClickWatermark = () => {
    setFeatureSelected("watermark");
  };

  const title = (() => {
    if (featureSelected === "posts") {
      return <Trans>Buy posts</Trans>;
    }
    if (featureSelected === "video") {
      return <Trans>Buy access to video posting</Trans>;
    }
    if (featureSelected === "watermark") {
      return <Trans>Buy Watermark slots</Trans>;
    }
    return <Trans>Power up my Plan</Trans>;
  })();

  return (
    <UiDialogResponsive fullWidth onClose={onClose} open title={title}>
      <UiBox display="flex" flexDirection="column">
        {!featureSelected && (
          <>
            {me.billing_policy_base === "classic" && (
              <UiBox mb={1}>
                <UiButton
                  align="left"
                  className={classes.button}
                  fullWidth
                  onClick={handleClickPosts}
                  startIcon={<UiIconPosts />}
                  variant="outlined"
                  {...testAppendAttr("id", "boost_buy_posts")}
                >
                  <Trans>Buy posts</Trans>
                </UiButton>
              </UiBox>
            )}
            {me.billing_policy_base === "classic" && (
              <UiBox mb={1}>
                <UiButton
                  align="left"
                  className={classes.button}
                  fullWidth
                  onClick={handleClickVideo}
                  startIcon={<IconYoutube />}
                  variant="outlined"
                  {...testAppendAttr("id", "boost_buy_video")}
                >
                  <Trans>Buy access to video posting</Trans>
                </UiButton>
              </UiBox>
            )}
            <UiBox mb={1}>
              <UiButton
                align="left"
                className={classes.button}
                fullWidth
                onClick={handleClickWatermark}
                startIcon={<UiIconWatermark />}
                variant="outlined"
                {...testAppendAttr("id", "boost_buy_watermark")}
              >
                <Trans>Buy Watermark slots</Trans>
              </UiButton>
            </UiBox>
          </>
        )}
        {featureSelected && (
          <>
            <UiBox mb={2}>
              <UiButton
                color="primary"
                onClick={handleClickBack}
                startIcon={<IconArrowBack />}
                variant="contained"
                {...testAppendAttr("id", "dialog_back")}
              >
                <Trans>Back</Trans>
              </UiButton>
            </UiBox>
            {featureSelected === "posts" && (
              <Posts onClose={onClose} onClickTryPro={onClickTryPro} />
            )}
            {featureSelected === "video" && (
              <Video onClose={onClose} onClickTryPro={onClickTryPro} />
            )}
            {featureSelected === "watermark" && (
              <Watermark onClose={onClose} onClickTryPro={onClickTryPro} />
            )}
          </>
        )}
      </UiBox>
    </UiDialogResponsive>
  );
};
